import { render, staticRenderFns } from "./VideoItem.vue?vue&type=template&id=1076aeff&"
import script from "./VideoItem.vue?vue&type=script&lang=js&"
export * from "./VideoItem.vue?vue&type=script&lang=js&"
import style0 from "./VideoItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports